import { Tenants } from "../constants/Tenants";

export class TenantService {
  private static instance: TenantService;
  private currentTenantName: string | null = null;

  private constructor() {}

  public static getInstance(): TenantService {
    if (!TenantService.instance) {
      TenantService.instance = new TenantService();
    }
    return TenantService.instance;
  }

  public getTenantName(): string {
    if (!this.currentTenantName) {
      this.currentTenantName = this.resolveTenantFromEnvironment();
    }
    return this.currentTenantName;
  }

  private resolveTenantFromEnvironment(): string {
    const hostname = window.location.hostname.toLowerCase();
    let tenantName: string | undefined;

    // for local dev
    if (process.env.NODE_ENV === "development" || hostname === "localhost") {
      const envTenant = process.env.VUE_APP_TENANT_NAME;
      if (envTenant) {
        tenantName = envTenant;
        return tenantName;
      }
    }
    // for deployed version
    if (
      hostname.includes("racing-ie") ||
      hostname.includes("racing.ie") ||
      hostname.includes("racing-irish")
    ) {
      tenantName = Tenants.Rewards4RacingIreland;
      return tenantName;
    }

    if (hostname.includes("racing")) {
      tenantName = Tenants.Rewards4Racing;
      return tenantName;
    }
    if (hostname.includes("imps")) {
      tenantName = Tenants.Rewards4Imps;
      return tenantName;
    }

    if (hostname.includes("tigers")) {
      tenantName = Tenants.Rewards4Tigers;
      return tenantName;
    }

    if (hostname.includes("affordablegolf")) {
      tenantName = Tenants.Rewards4AffordableGolf;
      return tenantName;
    }

    if (hostname.includes("golf")) {
      tenantName = Tenants.Rewards4Golf;
      return tenantName;
    }

    if (hostname.includes("wolves")) {
      tenantName = Tenants.Rewards4Wolves;
      return tenantName;
    }

    if (hostname.includes("lancashirecricket")) {
      tenantName = Tenants.Rewards4LancashireCricket;
      return tenantName;
    }

    if (hostname.includes("rugbyleague")) {
      tenantName = Tenants.Rewards4RugbyLeague;
      return tenantName;
    }

    if (hostname.includes("rewards4sport.com")) {
      tenantName = Tenants.Rewards4Sport;
      return tenantName;
    }

    console.warn(
      `[Tenant] Could not resolve tenant from hostname: ${hostname}, using default`,
    );
    return "";
  }
}

export default TenantService.getInstance();
